import { useState, useEffect } from 'react';
import { X, Download, Share } from 'lucide-react';

const DISMISS_KEY = 'cwf-install-dismissed';

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (dismissed || isStandalone || (!deferred && !isIOS)) return null;

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, '1'); setDismissed(true); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    dismiss();
  };

  return (
    <div className="bg-[#0A0A0A] border border-[#D4AF37]/50 rounded-sm p-4 mb-6 flex items-start gap-3" data-testid="install-prompt">
      <img src="/icons/icon-192.png" alt="CWF" className="w-10 h-10 rounded-sm flex-shrink-0" />
      <div className="flex-1">
        <p className="text-white text-sm font-semibold">Install the CWF Member App</p>
        {isIOS && !deferred ? (
          <p className="text-gray-400 text-xs mt-1 flex items-center gap-1 flex-wrap">Tap <Share size={12} className="inline text-[#D4AF37]" /> Share, then "Add to Home Screen" to install.</p>
        ) : (
          <p className="text-gray-400 text-xs mt-1">Add it to your home screen for quick access to your protocols and tracker.</p>
        )}
        {deferred && (
          <button onClick={install} className="mt-2 flex items-center gap-1.5 bg-[#C41E3A] hover:bg-[#A01830] text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-sm transition-colors" data-testid="install-btn">
            <Download size={12} /> Install App
          </button>
        )}
      </div>
      <button onClick={dismiss} className="text-gray-500 hover:text-white transition-colors" data-testid="install-dismiss"><X size={16} /></button>
    </div>
  );
};
